import './App.css';
import {useEffect, useRef, useState} from "react";
import Receipt from "./Reciept/Receipt";
import {getFNota, getNota, getOrder} from "./api/api";
import Order from "./order/Order";

import html2canvas from 'html2canvas';
import FNota from "./FNota/FNota";

function App() {

  //const [params, setParams] = useState({})
  const [messagae, setMessagae] = useState("Laddar...")
  const [reciept, setReciept] = useState(null)
  const [order, setOrder] = useState(null)
    const [fNota, setFNota] = useState(null)

  const contentRef = useRef(null);
  const canCloseWindow = !!window.opener;

  const handleDownloadImage = async () => {
    const element = contentRef.current;
    const canvas = await html2canvas(element);

    const data = canvas.toDataURL('image/jpg');
    const link = document.createElement('a');

    if (typeof link.download === 'string') {
      link.href = data;
      const name = order?.order.order00.notanr || reciept?.notanr || "";
      console.log(name);
      link.download = `kvitto-${name}.png`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      window.open(data);
    }
  };

  const setError = () => {
    const title = "Angiven länk är inkomplett eller felaktig";
    const subTitle = `Dubbelkolla url och försök igen`;
    setMessagae([title, subTitle])
  }


  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    const s = searchParams.get('s'); // e.g., "S0009999"
    const d = searchParams.get('d'); // e.g., "241124"
    const n = searchParams.get('n'); // e.g., "099427E"
    const c = searchParams.get('c'); // e.g., "12345"
    const o = searchParams.get('o');
    const f = searchParams.get("f")

    if(s && d && n && c){
      getNota(s,d,n,c).then((ret)=> {
        console.log(ret)
        if(ret === null)setError()
        setReciept(ret)
        setMessagae(null)
      })
    }else if(s&&d&&o&&c){
      getOrder(s,d,o,c).then((ret)=> {
        if(ret === null)setError()
        setOrder(ret)
        setMessagae(null)
      })
    }else if(s && d && f && c){
        getFNota(s, d, f, c).then((ret)=> {
            console.log(ret)
            if(ret === null)setError()
            setFNota(ret)
            setMessagae(null)
        })
    } else{
      setError()
    }
  }, []);

  const Render = () => {
    if(messagae){
      return (
          <div style={{
            marginTop: "40px",
            padding: "20px",
            textAlign: "center",
            backgroundColor: "#f9f9f9",
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            maxWidth: "600px",
            marginLeft: "auto",
            marginRight: "auto"
          }}>
            {Array.isArray(messagae) ? (
                <>
                  <h2 style={{ marginBottom: "10px", color: "#333" }}>{messagae[0]}</h2>
                  <h4 style={{ color: "#666" }}>{messagae[1]}</h4>
                </>
            ) : (
                <h2 style={{ color: "#555" }}>{messagae}</h2>
            )}
          </div>
      );
    }
    if(reciept){
      return <><Receipt data={reciept} printRef={contentRef}/></>
    }
    if(order){
      return <><Order data={order} printRef={contentRef} setMessagae={setMessagae}/></>
    }
    if(fNota)return <FNota data={fNota} printRef={contentRef}/>
    return (
        <div style={{
          marginTop: "40px",
          padding: "20px",
          textAlign: "center",
          backgroundColor: "#f9f9f9",
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          maxWidth: "600px",
          marginLeft: "auto",
          marginRight: "auto"
        }}>
          {Array.isArray(messagae) ? (
              <>
                <h2 style={{ marginBottom: "10px", color: "#333" }}>{messagae[0]}</h2>
                <h4 style={{ color: "#666" }}>{messagae[1]}</h4>
              </>
          ) : (
              <h2 style={{ color: "#555" }}>{messagae}</h2>
          )}
        </div>
    );

  }

  return (
      <div style={{display: 'flex', flexDirection: 'column', alignItems: "center"}}>
        {canCloseWindow &&
            <span
                onClick={window.close}

                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "4px",
                  margin: "15px auto 0 15px",
                  cursor: "pointer",
                  color: "#222",
                  fontWeight: "500",
                  fontSize: "20px",
                  userSelect: "none",
                }}
            >
              <span style={{fontSize: "22px", lineHeight: "1", position: "relative", top: 0}}>
                ❮
              </span>
              Tillbaka
            </span>


        }
        <Render/>
        {(reciept || order) && !messagae && <button className={"floatingButton"} onClick={handleDownloadImage}> Ladda ner</button>}
      </div>
  )


}

export default App;
